import React from 'react'
import "./Footer.scss";
import moment from 'moment';
function Footer() {
  return (
    <footer className='footer'>
        <p>Copyright@DSD-{moment().format('YYYY')}</p>   
    </footer>
  )
}

export default Footer